export default function Pause({ ...props }) {
	return (
		<svg
			width="12"
			height="14"
			viewBox="0 0 12 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect x="0.0820312" y="0.0791016" width="3.49609" height="13.8423" fill="#0026B8" />
			<rect x="8.41992" y="0.0791016" width="3.49609" height="13.8423" fill="#0026B8" />
		</svg>
	)
}
